import isValid from 'date-fns/isValid';
import parse from 'date-fns/parse';

/** Формат дат в ответах бэкенда: «01.09.2026 20:48:52». */
export const API_DATE_FORMAT = 'dd.MM.yyyy HH:mm:ss';

/**
 * Разбор даты из ответа API.
 *
 * Функция идемпотентна намеренно: class-transformer применяет @Transform и
 * родительского класса, и наследника, а повторный parse уже готовой Date
 * возвращал Invalid Date. Из-за этого create_date у OrderDetails был битым,
 * и сортировка заказов по дате молча не работала.
 */
export const parseApiDate = (value: unknown): Date | undefined => {
  if (value instanceof Date) return isValid(value) ? value : undefined;
  if (typeof value !== 'string' || !value.trim()) return undefined;
  const parsed = parse(value, API_DATE_FORMAT, new Date());
  return isValid(parsed) ? parsed : undefined;
};
